import * as React from "react"
import { Skeleton, Box } from "@mui/material"
import { CardSeeker } from "@ui-seeker/core"
import { isEmpty } from "@ui-seeker/utils"

import { useSkuDetailsDistributionData } from "./@hooks"
import SkuDetailsDistributionData from "./DistributionData"
import SkuDetailsDistributionTabs from "./DistributionTabs"


export default function SkuDetailsDistribution() {

    const { distributionData, tabs, isLoadingDistribution, tabSelected, handleChangeTabSelected } = useSkuDetailsDistributionData()

    if (isLoadingDistribution) return <Skeleton variant="rectangular" height={300} />
    if (isEmpty(distributionData)) return <></>

    return <CardSeeker title="Distribution">
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <SkuDetailsDistributionTabs
                tabs={tabs}
                tabSelected={tabSelected}
                onChange={handleChangeTabSelected}
            />

            <Box sx={{ width: '95%', mt: 2 }}>
                <SkuDetailsDistributionData distributionData={distributionData} tabSelected={tabSelected} />
            </Box>
            
        </Box>
    </CardSeeker>
}